export { reportsVersionedResource, appointmentReportsVersionedResource } from './requests';
